import React from 'react';
import { CommentStart, CommentEnd } from '../comments';
import { useConfig } from '../config-context';
export function SectionConditionalTable(props) {
    var backgroundColor = props.backgroundColor, children = props.children, width = props.width;
    var renderComments = useConfig().renderComments;
    if (!renderComments) {
        return React.createElement(React.Fragment, null, children);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(CommentStart, null),
        React.createElement("table", { align: "center", border: "0", cellPadding: "0", cellSpacing: "0", role: "presentation", style: { width: width + "px" }, width: width, bgcolor: backgroundColor },
            React.createElement("tr", null,
                React.createElement("td", { style: {
                        lineHeight: '0px',
                        fontSize: '0px',
                        msoLineHeightRule: 'exactly',
                    } },
                    React.createElement(CommentEnd, null),
                    children,
                    React.createElement(CommentStart, null)))),
        React.createElement(CommentEnd, null)));
}
//# sourceMappingURL=section-conditional-table.js.map